import {v4} from "uuid";
import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import ResultTable from "../../Table/ResultTable";
import EmptyLine from "../../EmptyLine";
import ComparisonCSName from "../../ComparisonCSName";

const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.M006.error_id: {
            return (
                <>
                    <div>
                        There are differences in the Manning’s n value at the following {row.data.length} cross sections.
                        <EmptyLine />
                    </div>
                    <div>
                        {
                            row.data.map(r => {
                                return renderMannData(r, globalVariables)
                            })
                        }
                    </div>
                </>
            )
        }
        case MessageCodes.Compare.MICS006.error_id: {
            return (
                <>
                    <div>
                        There are differences in the Manning’s n value at the following {row.data.length} Internal Bridge Cross Sections.
                        <EmptyLine />
                    </div>
                    <div>
                        {
                            row.data.map(r => {
                                return renderMannData(r, globalVariables)
                            })
                        }
                        <br/>
                    </div>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

const renderMannData = (row, globalVars) => {
    let data = row.mann_table
    const diff_data = []

    if(!data || data.length < 2 || !Array.isArray(data)) {
        return '{mann_table}'
    }

    data[0].forEach( (x, idx) => {
        if(data[1][idx][0] !== x[0] || data[1][idx][1] !== x[1])
            diff_data.push([idx, x[0], x[1], data[1][idx][0], data[1][idx][1]])
    })

    console.log(row?.matched_table)
    return (
        <div style={{overflowX: 'auto', padding: 8, overflowY: 'auto'}}>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: 125}}>
                            {<ComparisonCSName csName={row.cross_section} />}
                        </ResultHeaderCell>
                        {
                            row?.matched_table?.map((r, idx) => (
                                <ResultHeaderCell colSpan={2}>
                                    <b>{r?.number ? `n#${r.number}` : `-`}</b>
                                </ResultHeaderCell>
                            ))
                        }
                    </ResultRow>
                </ResultHeader>

                <ResultBody>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: 150}}>
                            <b>{globalVars?.sel_plan_title || 'Base'}</b>
                        </ResultHeaderCell>
                        {
                            row?.matched_table?.map(y => (
                                <>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{y?.base_cs?.toString()}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{y?.base_val || '-'}</ResultBodyCell>
                                </>
                            ))
                        }
                    </ResultRow>

                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: 150}}>
                            <b>{globalVars?.tar_plan_title || 'Base'}</b>
                        </ResultHeaderCell>
                        {
                            row?.matched_table?.map(y => (
                                <>
                                    <ResultBodyCell style={{textAlign: 'right', width: 50}}>{ResultCellHighlight(y?.base_cs?.toString() || '-', y?.cmp_cs?.toString() || '-')}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', width: 50}}>{ResultCellHighlight(y?.base_val || '-', y?.cmp_val || '-')}</ResultBodyCell>
                                </>
                            ))
                        }
                    </ResultRow>
                </ResultBody>
            </ResultTable>
        </div>
    )
}

export const C6 = {
    RenderDescription,

}